import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const FavouritesContext = createContext(null);

export const FavouritesProvider = ({ children }) => {
  const { user } = useAuth();
  const [ids, setIds] = useState(new Set());

  const refresh = useCallback(async () => {
    if (!user) {
      setIds(new Set());
      return;
    }
    try {
      const { data } = await api.get("/favourites/ids");
      setIds(new Set(data));
    } catch {
      setIds(new Set());
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const isFav = useCallback((factId) => ids.has(factId), [ids]);

  const toggle = useCallback(async (factId) => {
    const currently = ids.has(factId);
    // optimistic
    setIds((prev) => {
      const next = new Set(prev);
      if (currently) next.delete(factId);
      else next.add(factId);
      return next;
    });
    try {
      if (currently) await api.delete(`/favourites/${factId}`);
      else await api.post(`/favourites/${factId}`);
    } catch {
      refresh(); // revert on error
    }
  }, [ids, refresh]);

  return (
    <FavouritesContext.Provider value={{ ids, isFav, toggle, refresh }}>
      {children}
    </FavouritesContext.Provider>
  );
};

export const useFavourites = () => useContext(FavouritesContext);
